




































































import { defineComponent, PropType, ref, useFetch } from '@nuxtjs/composition-api';
import AppArchiveCard from '~/components/partials/App/AppArchiveCard.vue';
import AppArticleCard from '~/components/partials/App/AppArticleCard.vue';
import AppProducerCard from '~/components/partials/App/AppProducerCard.vue';
import AppRelatedContentsLayout from '~/components/partials/App/AppRelatedContentsLayout.vue';
import ContentRelatedEvent from '~/components/partials/Content/ContentRelatedEvent.vue';
import { useRelatedContents } from '~/composables/contents/useRelatedContents';
import { useTags } from '~/composables/contents/useTags';
import { ArticleCard, ArticleCategory, EditorProfile, RelatedProducerArticle } from '~/types/modules/contents';
import { EventSummaryResponseSchema, EventCardTags } from '~/types/modules/event';

export default defineComponent({
  components: {
    AppRelatedContentsLayout,
    AppArchiveCard,
    AppArticleCard,
    AppProducerCard,
    ContentRelatedEvent,
  },
  props: {
    relatedSpecialFeaturesIds: {
      type: Array as PropType<number[]>,
      default: () => [],
    },
    relatedMagazinesIds: {
      type: Array as PropType<number[]>,
      default: () => [],
    },
    relatedProducerArticlesIds: {
      type: Array as PropType<number[]>,
      default: () => [],
    },
    relatedEventsIds: {
      type: Array as PropType<number[]>,
      default: () => [],
    },
  },
  setup(props) {
    const relatedSpecialFeatures = ref<ArticleCard[]>([]);
    const relatedMagazines = ref<ArticleCard[]>([]);
    const categories = ref<ArticleCategory[]>([]);
    const authors = ref<EditorProfile[]>([]);
    const relatedProducers = ref<RelatedProducerArticle[]>([]);
    const relatedEvents = ref<EventSummaryResponseSchema[]>([]);
    const eventTags = ref<EventCardTags[]>([]);
    const { getRelatedSpecialFeatures, getRelatedMagazines, getRelatedProducers, getRelatedEvents } =
      useRelatedContents();
    const { findTagsByEventId } = useTags();

    useFetch(async () => {
      // 関連する特集
      if (props.relatedSpecialFeaturesIds.length > 0) {
        relatedSpecialFeatures.value = (await getRelatedSpecialFeatures(props.relatedSpecialFeaturesIds)) || [];
      }

      // 関連する読み物
      if (props.relatedMagazinesIds.length > 0) {
        const result = await getRelatedMagazines(props.relatedMagazinesIds);
        relatedMagazines.value = result?.articles || [];
        categories.value = result?.categories || [];
        authors.value = result?.authors || [];
      }

      // 関連する生産者特集
      if (props.relatedProducerArticlesIds.length > 0) {
        const result = await getRelatedProducers(props.relatedProducerArticlesIds);
        relatedProducers.value = result || [];
      }

      // 関連するイベント
      if (props.relatedEventsIds.length > 0) {
        const result = await getRelatedEvents(props.relatedEventsIds);
        relatedEvents.value = result?.events || [];
        eventTags.value = result?.tags || [];
      }
    });

    return {
      relatedSpecialFeatures,
      relatedMagazines,
      categories,
      authors,
      relatedProducers,
      relatedEvents,
      eventTags,
      findTagsByEventId,
    };
  },
});
